<template>
  <div>
    <topStarView></topStarView>


    <div v-if="!isShowDetails">
      <commentType :count="count"></commentType>
      <postCommentView :comment_parent="''" :isShowPostStar="isShowPostStar" :count="count">
      </postCommentView>
      <NCommentView @clickMore="clickMore" :commentList="commentList" :count="count" @clickPage="pageLisenter">
      </NCommentView>
    </div>

    <div v-else>
      <replyCommentDetailsView @clickDetaits="closeDetaite" :details="detailsInfo" @goodClick="goodClick">
      </replyCommentDetailsView>
    </div>

  </div>
</template>
<script>
import topStarView from '../view/topStarView.vue';
import StarRating from 'vue-star-rating'
import postCommentView from '../view/postCommentView.vue';
import replyCommentDetailsView from '../view/replyCommentDetailsView.vue';
import commentView from '../view/commentList.vue';
import NCommentView from '../view/nCommentList.vue';
import commentType from '../view/CommentType.vue';
import { addEmit, resultEmitEvent } from "../util/event";
import { base_url, getPostId } from '../util/mock.js';
import { AccountStore } from "../util/Account.js";
import Toast from "../components/message.js";
export default {
  name: 'Home',

  props: {
    title: String,
    msg: String,
  },
  components: { topStarView, postCommentView, StarRating, replyCommentDetailsView, NCommentView, commentType },

  data() {
    return {
      content: " Looking forward to its future development 😄～",
      isShowDetails: false,
      detailsInfo: {},
      commentList: [],
      page: 1,
      commentType: 0,
      count: 0,
      isShowPostStar: true,
    }
  },

  watch: {

  },

  methods: {
    doClose() {
      this.show = false;
    },


    async getInitData() {
      let post_id = getPostId();
      console.log(post_id + "=====post_id===" + window.location.href);
      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        body: new URLSearchParams({
          action: 'bee_get_post_user_info_callback',
          _wpnonce: "wp_nonce",
          post_id: post_id,
        }),
      };

      const ajaxData = await fetch(`${base_url()}/wp-admin/admin-ajax.php`, options)
      let data = await ajaxData.json();
      let userData = data.data.data;
      console.log(userData.user)
      AccountStore.setValue(userData.user);
      if (data.data.uScore != 0) {
        this.isShowPostStar = false;
      } else {
        this.isShowPostStar = false;
      }
      // this.getScoreData();
    },


    async getScoreData() {

      let post_id = getPostId();
      console.log(post_id);

      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        body: new URLSearchParams({
          action: 'bee_rest_post_get_score_callback',
          _wpnonce: "wp_nonce",
          post_id: post_id,
        }),
      };

      const ajaxData = await fetch(`${base_url()}/wp-admin/admin-ajax.php`, options)
      let data = await ajaxData.json();
      this.tgJs = data.data.data;
      console.log(this.tgJs)
    },
    closeDetaite() {
      this.isShowDetails = false;
    },
    clickMore(item) {
      this.detailsInfo = item;
      this.isShowDetails = true;
    },


    async getPostComment() {
      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        body: new URLSearchParams({
          action: 'bee_get_post_comment_callback',
          _wpnonce: "wp_nonce",
          post_id: this.post_id,
          page: this.page,
          type: this.commentType,
        }),
      };
      const ajaxData = await fetch(`${base_url()}/wp-admin/admin-ajax.php`, options)
      let data = await ajaxData.json()
      console.log(data);
      if (data.data.code == 200) {
        this.commentList = data.data.data;
        this.count = data.data.count;
        addEmit("comment_count", this.count);
      } else {
        Toast(data.data.message, 'error');
      }

    },

    pageLisenter(p) {
      this.page = p;
      console.log(this.page + "===page")
      this.getPostComment();
    },

    async goodClick(r) {
      if (AccountStore.accountInfo == null || AccountStore.accountInfo.user_id == undefined
        || AccountStore.accountInfo.user_id == null) {
        window.location.href = AccountStore.loginUrl;
        return;
      }
      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        body: new URLSearchParams({
          action: 'bee_rest_post_add_comment_good_callback',
          _wpnonce: "wp_nonce",
          comment_id: this.detailsInfo.comment.comment_ID,
        }),
      };
      const ajaxData = await fetch(`${base_url()}/wp-admin/admin-ajax.php`, options)
      let data = await ajaxData.json()
      console.log(data);
      if (data.data.code == 200) {
        Toast("success", "success");
        if (this.detailsInfo.isGood) {
          this.detailsInfo.isGood = false;
          this.detailsInfo.good = this.detailsInfo.good - 1;
        } else {
          this.detailsInfo.good = this.detailsInfo.good + 1;
          this.detailsInfo.isGood = true;
        }
      } else {
        Toast(data.data.message, 'error');
      }
    }

  },

  mounted() {
    // this.getData();
    this.post_id = getPostId();
    this.getPostComment();
    resultEmitEvent("commentTypeListener", (res) => {
      this.page = 1;
      if (res == 0) {
        this.commentType = 0;
      } else if (res == 1) {
        this.commentType = 1;
      }
      this.getPostComment();
    });
  },


}


</script>

<style scoped>
img {
  width: 38px;
  height: 38px;
}

.user_header_layout {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.reply_layout {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.line {
  display: flex;
  background-color: #EFEFEF;
  height: 1px;
  margin-top: 16px;
  margin-bottom: 16px;
  margin: 16px;
}

.inputLayoutStyle {
  display: flex;
  min-height: 60px;
  background-color: #f8f8f8;
  border-radius: 8px;
  width: 100%;
  border-color: #f8f8f8;
}

.header_img {
  width: 38px;
  height: 38px;
  border-radius: 9999px;
}
</style>
